import AdvertisementText from './AdvertisementText';
export default AdvertisementText;